import Navbar from "../Components/Navbar";
import Topbar from "../Components/Topbar";
import "notyf/notyf.min.css"; // for React, Vue and Svelte
import { Link } from "react-router-dom";

function SupportFiles() {
  return (
    <>
      <div className="flex flex-row w-full">
        <Navbar />

        <div className="flex flex-col w-full bg-gray-100 ml-60">
          <Topbar />

          <div className="bg-white px-4 sm:px-6 lg:px-8 border border-gray-200 ml-10 mr-10 mt-10 mb-40">
            <form>
              <div className="space-y-12">
                <div className="mt-10">
                  <div className="sm:flex sm:items-center">
                    <div className="sm:flex-auto">
                      <h1 className="text-2xl font-semibold leading-6 text-gray-900 mb-5">
                        Support Files
                      </h1>
                    </div>
                  </div>
                  <div className="mt-8 flow-root mb-10">
                    <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                      <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                        <table className="min-w-full divide-y divide-gray-300">
                          <thead>
                            <tr>
                              <th
                                scope="col"
                                className="py-3.5 pl-4 pr-3 text-left text-sm font-medium text-gray-900 sm:pl-0"
                              >
                                Support File Type
                              </th>

                              <th
                                scope="col"
                                className="px-3 py-3.5 text-left text-sm font-medium text-gray-900"
                              ></th>
                            </tr>
                          </thead>
                          <tbody className="divide-y divide-gray-200">
                            <tr>
                              <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-500 sm:pl-0">
                                Type Pieces
                              </td>

                              <td className="block text-right">
                                <span className="mt-2 isolate inline-flex rounded-md shadow-sm">
                                  <Link to={`/type-pieces`}>
                                    <button
                                      type="button"
                                      className="relative -ml-px inline-flex items-center bg-green-600 hover:bg-green-700 px-3 py-2 text-sm font-semibold text-white ring-1 ring-inset ring-gray-300 focus:z-10"
                                    >
                                      View
                                    </button>
                                  </Link>
                                </span>
                              </td>
                            </tr>
                            <tr>
                              <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-500 sm:pl-0">
                                Vendor Details
                              </td>

                              <td className="block text-right">
                                <span className="mt-2 isolate inline-flex rounded-md shadow-sm">
                                  <Link to={`/vendor-details`}>
                                    <button
                                      type="button"
                                      className="relative -ml-px inline-flex items-center bg-green-600 hover:bg-green-700 px-3 py-2 text-sm font-semibold text-white ring-1 ring-inset ring-gray-300 focus:z-10"
                                    >
                                      View
                                    </button>
                                  </Link>
                                </span>
                              </td>
                            </tr>
                            <tr>
                              <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-500 sm:pl-0">
                                Departments
                              </td>

                              <td className="block text-right">
                                <span className="mt-2 isolate inline-flex rounded-md shadow-sm">
                                  <Link to={`/departments`}>
                                    <button
                                      type="button"
                                      className="relative -ml-px inline-flex items-center bg-green-600 hover:bg-green-700 px-3 py-2 text-sm font-semibold text-white ring-1 ring-inset ring-gray-300 focus:z-10"
                                    >
                                      View
                                    </button>
                                  </Link>
                                </span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default SupportFiles;
